import {memo, useEffect, useContext } from 'react'
import MapContext from './MapContext'
import { useMapFavorites } from '../../slices/map'
import settings from '../../conf'
import { useSettings } from '../../slices/settings'

import { layers } from './styles/favorites.js'

const ICON_NAME = 'favorite-marker'

const FavoritesLayer = memo((props) => {
  const map = useContext(MapContext)
  const favorites = useMapFavorites() || []
  const { zoom } = useSettings()

  useEffect(() => {
    if (!map) return null

    if (!map.getSource('favorites')){
      map.addSource('favorites', {
        type: 'geojson',
        data: null,
        cluster: true,
        clusterMaxZoom: 18, // Max zoom to cluster points on
        clusterRadius: 15
      }); 
      map.loadImage(settings.STATIC_URL + 'images/favorite-marker.png',  function(error, image) {
        if (error) throw error;
        if (!map.hasImage(ICON_NAME)) map.addImage(ICON_NAME, image);
      })
    }
    return () => {
      if (!map || map._removed) return
      for (const layer of layers(zoom)) {
        map.removeLayer(layer.id)
      }
      map.removeSource('favorites')
      if (map.hasImage(ICON_NAME)) map.removeImage(ICON_NAME);
    }
  }, [map])


  useEffect(() => {
    if (!map) return null

    for (const layer of layers(zoom)) {
      const mapLayer = map.getLayer(layer.id)
      if (mapLayer) {
        for (const props in layer.layout){
            map.setLayoutProperty(layer.id, props, layer.layout[props])
        }
        for (const props in layer.paint){
            map.setPaintProperty(layer.id, props, layer.paint[props])
        }
      } else {
        map.addLayer(layer)
      }
    }

   }, [map, zoom])

  useEffect(()=>{
    if (!map) return
    const geojson = {
      'type': 'FeatureCollection',
      'features': []
    };
    for (feature of favorites){
      geojson.features.push({
        'type': 'Feature',
        'geometry': {
          'type': 'Point',
          'coordinates': feature.lnglat
        },
        'properties': {
            'id': feature.id,
            'type': feature.type,
            'label': feature.label,
        }
      })
    }
    map.getSource('favorites').setData(geojson);
  }, [map, favorites])

  return null

})

export default FavoritesLayer
